export default {
    modal: {
        title: 'Έχεις φτάσει το όριο',
        body: 'Για να συνεχίσεις, διέγραψε κάποια παλιότερη εγγραφή.',
        counter: 'Χρήση: {current} / {limit}',
        contact: 'Πιστεύεις ότι αυτό είναι λάθος; Επικοινώνησε μαζί μας.',
        close: 'Το κατάλαβα',
    },
    chip: {
        title: 'Όριο λογαριασμού',
        note: 'Σε ορισμένες κατηγορίες ισχύουν όρια στον λογαριασμό σου.',
    },
}
